import React from 'react';

import {
  TitleContainer,
  ChildrenContainer
} from '../../styles/GenericContentContainer.styled';

type GenericContentContainerProps = {
  title: string;
  children?: React.ReactNode;
};

export const GenericContentContainer = ({
  title,
  children
}: GenericContentContainerProps) => {
  return (
    <>
      <TitleContainer>{title}</TitleContainer>
      <ChildrenContainer>{children}</ChildrenContainer>
    </>
  );
};
